import React from 'react';
import { FallbackProps } from '@kp/react-sdk/app-insights';
import { ErrorGeneric } from '../ErrorGeneric';

export const ErrorFallback: React.FC<FallbackProps> = ({ error }) => (
  <ErrorGeneric error={error} />
);
